





























































export default {
	name: 'Organization',
	data() {
		return {
			inputField: '',
			// loading: false,
			organizationName: '',
		};
	},
	computed: {
		// Sign-up lives in the auth app; carry the language over with it.
		signUpUrl(): string {
			return this.$withLocale(
				'https://auth-legacy.rambox.app/website?redirect_uri=https%3A%2F%2Frambox.app%2Fthanks-joining%2F&response_type=token&scope=organization%20email'
			);
		},
	},
	methods: {
		enterpriseLogin(): void {
			if (this.inputField === '') return;
			this.$router.push(`/${this.inputField}/signin/`);
			this.inputField = '';
		},
	},
};
